import React from 'react';
import Profile from './Profile/Profile';
import PrepareDocument from './PrepareDocument/PrepareDocument';

const Preparation = () => {
  return (
    <div>
      <Profile />
      <PrepareDocument />
    </div>
  );
};

export default Preparation;